import { useState } from "react";
import { MessageSquareText } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// Ürün Açıklaması (satır notu): taslak yerel tutulur, yalnız kapanınca satıra yazılır (yazarken yeniden hesap yok)
export default function LineNote({ value, onSave, sku }) {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(value || "");
  const toggle = (o) => {
    if (o) setDraft(value || "");
    else if ((draft.trim() || null) !== (value || null)) onSave(draft.trim() || null);
    setOpen(o);
  };
  return (
    <Popover open={open} onOpenChange={toggle}>
      <PopoverTrigger asChild>
        <button type="button" title={value || "Ürün açıklaması ekle"} data-testid={`qs-line-note-btn-${sku}`}
          className={`h-7 w-7 shrink-0 rounded flex items-center justify-center border transition-colors ${value ? "bg-amber-100 border-amber-300 text-amber-800" : "border-transparent text-slate-400 hover:text-slate-700 hover:border-slate-200"}`}>
          <MessageSquareText className="h-4 w-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-80 p-2" data-testid={`qs-line-note-pop-${sku}`}>
        <div className="text-[11px] font-semibold text-slate-500 mb-1">Ürün Açıklaması · {sku}</div>
        <textarea autoFocus rows={3} maxLength={500} value={draft} onChange={(e) => setDraft(e.target.value)} placeholder="Örn. Kırmızı renk, 40x60 ebat, özel ambalaj"
          onKeyDown={(e) => { if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) toggle(false); }}
          className="w-full rounded border border-slate-200 p-2 text-[13px] focus:outline-none focus:ring-2 focus:ring-blue-600/30" data-testid={`qs-line-note-input-${sku}`} />
        <div className="flex justify-between items-center mt-1 text-[11px] text-slate-400">
          <span>{draft.length}/500 · Ctrl+Enter kaydet</span>
          <span className="flex gap-2">
            {draft && <button type="button" className="text-rose-600" onClick={() => setDraft("")} data-testid={`qs-line-note-clear-${sku}`}>Temizle</button>}
            <button type="button" className="text-blue-700 font-semibold" onClick={() => toggle(false)} data-testid={`qs-line-note-save-${sku}`}>Tamam</button>
          </span>
        </div>
      </PopoverContent>
    </Popover>
  );
}
